import cx from 'classnames'
import React from 'react'

import Icon from '@f/elements/Icon'

import { Nullable } from '@f-fertighaus/applications/Next/types/utility'
import { ReviewRating as Rating } from '@f-fertighaus/applications/SalesAgentDashboard/interfaces/SADBReview'
import { computeStarColors } from '@f-fertighaus/components/ReviewForm/RatingWidget/RatingWidget'

const ReviewRatingMulticolor = ({ rating }: { rating: Nullable<Rating> }) => {
  const colors = computeStarColors(rating, true)

  return (
    <div className='f-d-flr'>
      {Object.entries(colors).map(([key, value]) => (
        <Icon
          key={key}
          icon='star-filled-16px-fill'
          {...value}
          width='16px'
          height='16px'
          style={{ marginRight: '1px', strokeWidth: 0.5 }}
        />
      ))}
    </div>
  )
}

const ReviewRatingMonoColor = ({ rating }: { rating: Nullable<Rating> }) => {
  const colors = computeStarColors(rating, true)

  return (
    <div className='f-d-flr'>
      {Object.entries(colors).map(([key, value]) => (
        <Icon
          key={key}
          icon='star-filled-16px-fill'
          className={cx(
            value.stroke === '#D2D4D9' ? 'f-c-st-neu050' : 'f-c-st-suc400',
            value.stroke === '#D2D4D9' ? 'f-c-fi-neu50' : 'f-c-fi-suc100'
          )}
          width='16px'
          height='16px'
          style={{ marginRight: '1px', strokeWidth: 0.5 }}
        />
      ))}
    </div>
  )
}

interface ReviewRatingProps {
  rating: Nullable<Rating>
  variant?: 'multicolor' | 'monocolor'
}

export const ReviewRating = ({
  rating,
  variant = 'multicolor'
}: ReviewRatingProps) =>
  ({
    multicolor: <ReviewRatingMulticolor rating={rating} />,
    monocolor: <ReviewRatingMonoColor rating={rating} />
  }[variant])
